// import React, { useMemo, useState } from 'react';
// import '../DashboardUnique.css';

// const ShimmerCard = () => (
//   <div className="govdash-villageCard-final">
//     <div className="village-shimmer" style={{ height: '1rem', marginBottom: '0.6rem' }}></div>
//     <div className="village-shimmer" style={{ height: '1.7rem' }}></div>
//   </div>
// );

// const NoDataCard = () => (
//   <div className="govdash-villageCard-final govdash-noVillageCard">
//     <div className="govdash-noDataIcon">
//       <i className="fas fa-village fa-2x"></i>
//     </div>
//     <div className="govdash-noDataTitle">No Villages Found</div>
//     <div className="govdash-noDataDesc">
//       {document.querySelector('.govdash-searchInput')?.value
//         ? 'Try searching with different keywords'
//         : 'No villages available under this Yojana'}
//     </div>
//   </div>
// );
// export default function VillageDashboardGrid({ villages = [], onSelect, isLoading = false }) {
//   const [search, setSearch] = useState('');
//   const themes = ['glass-0', 'glass-1', 'glass-2', 'glass-3', 'glass-4'];

//   const filteredVillages = useMemo(() => {
//     if (!search.trim()) return villages.filter(v => v?.VillageNameEnglish?.trim());
//     return villages.filter(v =>
//       v?.VillageNameEnglish?.toLowerCase().includes(search.toLowerCase())
//     );
//   }, [villages, search]);

//   return (
//     <div style={{ position: "relative" }}>
//       <div className="govdash-totalCountBadge" style={{ position: "absolute", zIndex: "9999", left: "0px", top: "-60px" }}>
//         <span className="govdash-totalLabel">Total Villages :</span>
//         <span className="govdash-totalNumber">{villages.length}</span>
//       </div>
//       <div className="govdash-searchWrapper "
//         style={{ position: "absolute", zIndex: "9999", right: "0px", top: "-80px" }}>
//         <i className="fas fa-search"></i>
//         <input
//           type="text"
//           placeholder="Search Village Name..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="govdash-searchInput"
//         />
//         {search && (
//           <button onClick={() => setSearch('')} className="govdash-clearSearch">
//             <i className="fas fa-times"></i>
//           </button>
//         )}
//       </div>

//       <div className="govdash-villageGrid-final">
//         {isLoading ? (
//           Array(50).fill().map((_, i) => <ShimmerCard key={i} />)
//         ) : filteredVillages.length > 0 ? (
//           filteredVillages.map((v, idx) => {
//             const theme = themes[idx % 5];
//             const hasAmount = v?.TotalAmount > 0;
//             return (
//               <div key={v.id} className={`govdash-villageCard-final yojna-${theme}`} onClick={() => onSelect(v)}>
//                 <div className="village-header-final">
//                   <div className="village-name-final">{v.VillageNameEnglish}</div>
//                   {v?.VillageVoterCount > 0 && (
//                     <div className="voter-badge">
//                       {v.VillageVoterCount.toLocaleString()} Voters
//                     </div>
//                   )}
//                 </div>
//                 <div className="beneficial-row-final">
//                   <span className="label">Labharthi</span>
//                   <span className="value">{v?.BeneficialCount?.toLocaleString() || '0'}</span>
//                 </div>
//                 {hasAmount && (
//                   <div className="amount-row-final">
//                     ₹{v.TotalAmount.toLocaleString('en-IN')}
//                   </div>
//                 )}
//               </div>
//             );
//           })
//         ) : (
//           <NoDataCard />
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useMemo, useState } from "react";
import "../DashboardUnique.css";
import { exportVillageToExcel, exportVillageToPDF, exportYojanaToExcel, toIndianCurrency, toIndianCurrencyVillageCard } from "../../../MethodMaster/JSXComponentMothod";
import { toast } from "react-toastify";

const ShimmerCard = () => (
  <div className="govdash-villageCard-final">
    <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
    <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
  </div>
);

const NoDataCard = () => (
  <div className="govdash-villageCard-final govdash-noVillageCard">
    <div className="govdash-noDataIcon">
      <i className="fas fa-village fa-2x"></i>
    </div>
    <div className="govdash-noDataTitle">No Villages Found</div>
    <div className="govdash-noDataDesc">
      {document.querySelector(".govdash-searchInput")?.value ? "Try searching with different keywords" : "No villages available under this Yojana"}
    </div>
  </div>
);

export default function VillageDashboardGrid({ villages = [], onSelect, isLoading = false }) {
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("all"); // all | used | notused

  const themes = ["glass-0", "glass-1", "glass-2", "glass-3", "glass-4"];

  const { allVillages, usedVillages, notUsedVillages } = useMemo(() => {
    const valid = villages.filter((v) => v?.VillageNameEnglish?.trim());
    const used = valid.filter((v) => (v.BeneficialCount || 0) > 0);
    const notUsed = valid.filter((v) => (v.BeneficialCount || 0) === 0);
    return { allVillages: valid, usedVillages: used, notUsedVillages: notUsed };
  }, [villages]);

  const filteredVillages = useMemo(() => {
    let data = activeTab === "used" ? usedVillages : activeTab === "notused" ? notUsedVillages : allVillages;

    if (!search.trim()) return data;

    return data.filter((v) => v.VillageNameEnglish?.toLowerCase().includes(search.toLowerCase()));
  }, [allVillages, usedVillages, notUsedVillages, activeTab, search]);

  const handleExcelExport = () => {
    let exportVillages = [];
    let tabTitle = "";
    let summaryText = "";
    let includeAmount = false;

    if (activeTab === "used") {
      exportVillages = usedVillages;
      // tabTitle = "Used Yojana Villages";
      summaryText = `Used Yojana Villages: ${usedVillages.length}`;
      includeAmount = true;
    } else if (activeTab === "notused") {
      exportVillages = notUsedVillages;
      // tabTitle = "Not Used Yojana Villages";
      summaryText = `Not Used Yojana Villages: ${notUsedVillages.length}`;
      includeAmount = false;
    } else {
      exportVillages = allVillages;
      // tabTitle = "All Yojana Villages";
      summaryText = `Total: ${allVillages.length} | Used: ${usedVillages.length} | Not Used: ${notUsedVillages.length}`;
      includeAmount = true;
    }

    const finalData = search.trim() ? exportVillages.filter((v) => v.VillageNameEnglish?.toLowerCase().includes(search.toLowerCase())) : exportVillages;

    const yojanaName = villages[0]?.GramYojnaName || "ગામ રિપોર્ટ";

    const exportData = [
      { "Village Name": yojanaName },
      // { 'Village Name': tabTitle },
      { "Village Name": summaryText },
      // { 'Village Name': '' },
    ];

    // Dynamic Header
    const header = { "Village Name": "Village Name", Voters: "Voters Count", Labharthi: "Labharthi Count", LabharthiLabh: "Labharthi Labh" };
    if (includeAmount) header.Amount = "Amount";

    exportData.push(header);

    finalData.forEach((v, i) => {
      const row = {
        "Village Name": v.VillageNameEnglish || "",
        Voters: v.VillageVoterCount?.toLocaleString() || "0",
        Labharthi: v.BeneficialCount?.toLocaleString() || "0",
        LabharthiLabh: v.TotalLabharthiLabh.toLocaleString() || "0",
      };
      if (includeAmount && v.TotalAmount > 0) {
        row.Amount = `₹${v.TotalAmount.toLocaleString("en-IN")}`;
      }
      exportData.push(row);
    });

    exportVillageToExcel(exportData, `${yojanaName}_${tabTitle.replace(/ /g, "_")}`);
    // toast.success(`${tabTitle} exported!`);
  };
  const handlePDFExport = () => {
    let exportVillages = [];
    let tabTitle = "";
    let summaryText = "";

    if (activeTab === "used") {
      exportVillages = usedVillages;
      tabTitle = `Used Yojana Villages: ${usedVillages.length} (from total ${allVillages.length})`;
      // summaryText = `Used Yojana Villages: ${usedVillages.length} (from total ${allVillages.length})`;
    } else if (activeTab === "notused") {
      exportVillages = notUsedVillages;
      tabTitle = `Not Used Yojana Villages: ${notUsedVillages.length} (from total ${allVillages.length})`;
      // summaryText = `Not Used Yojana Villages: ${notUsedVillages.length} (from total ${allVillages.length})`;
    } else {
      exportVillages = allVillages;
      // tabTitle = "All Yojana Villages";
      tabTitle = `Total: ${allVillages.length} | Used: ${usedVillages.length} | Not Used: ${notUsedVillages.length}`;
    }

    const finalData = search.trim() ? exportVillages.filter((v) => v.VillageNameEnglish?.toLowerCase().includes(search.toLowerCase())) : exportVillages;

    const yojanaName = villages[0]?.GramYojnaName || "Village Report";

    const pdfData = [
      { "Village Name": yojanaName },
      { "Village Name": tabTitle },
      // { "Village Name": summaryText },
      { "Village Name": "" },
    ];

    const hasAmount = activeTab !== "notused";

    // pdfData.push({
    //   // "Village Name": "Village Name",
    //   // "Voters": "Voters Count",
    //   // "Labharthi": "Labharthi Count",
    //   ...(hasAmount && { Amount: "Amount" })
    // });

    finalData.forEach((v) => {
      const row = {
        "Village Name": v.VillageNameEnglish || "",
        Voters: v.VillageVoterCount?.toLocaleString() || "0",
        Labharthi: v.BeneficialCount?.toLocaleString() || "0",
      };
      if (hasAmount && v.TotalAmount > 0) {
        row.Amount = "₹" + v.TotalAmount.toLocaleString("en-IN");
      }
      pdfData.push(row);
    });

    exportVillageToPDF(pdfData, `${yojanaName}_${tabTitle.replace(/ /g, "_")}`);
    // toast.success("PDF downloaded successfully!");
  };
  return (
    <div style={{ position: "relative" }}>
      {/* Tabs */}
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
        <div className="d-flex flex-wrap gap-3">
          <button onClick={() => setActiveTab("all")} className={`govdash-tabBtn ${activeTab === "all" ? "active" : ""}`}>
            All Yojana Villages <span className="govdash-tabCount">{allVillages.length}</span>
          </button>
          <button onClick={() => setActiveTab("used")} className={`govdash-tabBtn ${activeTab === "used" ? "active" : ""}`}>
            Used Yojana Villages <span className="govdash-tabCount ">{usedVillages.length}</span>
          </button>
          <button onClick={() => setActiveTab("notused")} className={`govdash-tabBtn ${activeTab === "notused" ? "active" : ""}`}>
            Not Used Yojana Villages <span className="govdash-tabCount ">{notUsedVillages.length}</span>
          </button>
        </div>
        <div className="d-flex">
          <div>
            <button disabled={isLoading} onClick={handleExcelExport} style={{ position: "relative", top: "10px" }} className="me-2 govdash-excelBtn">
              <i className="fas fa-file-excel"></i> Export to Excel
            </button>
          </div>
          {/* <div>
          <button disabled={isLoading} onClick={handlePDFExport}  style={{ position: "relative", top: "10px" }} className="me-2  govdash-pdfBtn">
            <i className="fas fa-file-pdf"></i> Download PDF
          </button>
          </div> */}
          <div className="d-flex gap-3 align-items-center ">
            <div className="govdash-searchWrapper govdash-searchWrapper-village">
              <i className="fas fa-search"></i>
              <input type="text" placeholder="Search Village Name..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Grid */}
      <div className="govdash-villageGrid-final">
        {isLoading ? (
          Array(50)
            .fill()
            .map((_, i) => <ShimmerCard key={i} />)
        ) : filteredVillages.length > 0 ? (
          filteredVillages.map((v, idx) => {
            const theme = themes[idx % 5];
            const hasAmount = v?.TotalAmount > 0;
            // const hasLabharthiLabh = v?.TotalLabharthiLabh > 0;
            const isUsed = (v.BeneficialCount || 0) > 0;

            return (
              <div key={v.id} className={`govdash-villageCard-final yojna-${theme} ${!isUsed ? "govdash-unusedVillage" : ""}`} onClick={() => onSelect(v)}>
                <div className="village-header-final">
                  <div className="village-name-final">{v.VillageNameEnglish}</div>
                  {v?.VillageVoterCount > 0 && <div className="voter-badge">{v.VillageVoterCount.toLocaleString()} Voters</div>}
                </div>
                {/* <div className="beneficial-row-final">
                  <span className="label">Labharthi</span>
                  <span className="value">{v?.BeneficialCount?.toLocaleString() || "0"}</span>
                </div> */}
                <div className="beneficial-row-final">
                  <span className="label">Labharthi</span>
                  <span className="value">{v?.BeneficialCount?.toLocaleString()}</span>
                </div>

                <div className="labh-amount-strip">
                  <span className="label">Labharthi Labh</span>
                  {/* <span className="value">{v?.TotalLabharthiLabh?.toLocaleString()}</span> */}
                  <span className="value">{v?.TotalLabharthiLabh?.toLocaleString()}</span>
                </div>
                {/* {hasAmount && <div className="amount-row-final">₹{v.TotalAmount.toLocaleString("en-IN")}</div>} */}
                {hasAmount && <div className="amount-row-final">{toIndianCurrencyVillageCard(v.TotalAmount)}</div>}
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
    </div>
  );
}
